"use client";

import { useUserRealmId } from "@easybiz/component-shared";
import { doc, getFirestore, onSnapshot } from "firebase/firestore";
import { useEffect, useState } from "react";

export default (orderId) => {
  const realmId = useUserRealmId();
  const [historyDoc, setHistoryDoc] = useState();

  useEffect(() => {
    if (realmId && orderId) {
      return onSnapshot(doc(getFirestore(), `realms/${realmId}/order_history/${orderId}`), setHistoryDoc);
    }
  }, [realmId, orderId]);

  return historyDoc;
};
